import { render, staticRenderFns } from "./WallSponsorsBlockItemSettings.vue?vue&type=template&id=15041578"
import script from "./WallSponsorsBlockItemSettings.vue?vue&type=script&lang=js"
export * from "./WallSponsorsBlockItemSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports